module.exports = __webpack_public_path__ + "static/media/reassign-pharmacy.acc4060e.svg";